import { FC, memo } from 'react';

import GenericLayout from '../components/generic-layout/GenericLayout';
import Grid2 from '../components/grid/Grid2';
import { H2 } from '../components/heading/Hx';
import List from '../components/list/List';
import ListItem from '../components/list/ListItem';
import Route from '../components/route/Route';
import { router } from '../components/route/utils';
import NoPageImageSection from '../components/section/NoPageImageSection';

const Sitemap: FC = () => {
  const routes = router.getRoutes();

  const countLeft = Math.ceil(routes.length / 2);
  const left = routes.slice(0, countLeft);
  const right = routes.slice(countLeft);

  return (
    <GenericLayout title='Sitemap'>
      <NoPageImageSection>
        <H2 center>Sitemap</H2>

        <Grid2 spacing={{ md: '2rem', xs: '0' }}>
          <Grid2.Centered>
            <List>
              {left.map(({ path, text }) => (
                <ListItem>
                  <Route href={path} key={text}>
                    {text}
                  </Route>
                </ListItem>
              ))}
            </List>
          </Grid2.Centered>
          <Grid2.Centered>
            <List>
              {right.map(({ path, text }) => (
                <ListItem>
                  <Route href={path} key={text}>
                    {text}
                  </Route>
                </ListItem>
              ))}
            </List>
          </Grid2.Centered>
        </Grid2>
      </NoPageImageSection>
    </GenericLayout>
  );
};

export default memo(Sitemap);
